<template>
    <div class="B2BArticleSlider">
        <div class="xl:absolute xl:ml-[2vw] xl:w-[950px]">
           <div class="carousel">
                <VSlickCarousel v-bind="settings">
                <div v-for="article in articles" :key="article.id">
                    <div class="relative mx-3 mb-3 flex flex-col overflow-hidden drop-shadow-md">
                        <img
                            v-if="article?.img"
                            class="m-0 h-[204px] w-full rounded-t-lg object-cover object-center"
                            loading="lazy"
                            :src="article.img"
                        />
                        <div
                            class="flex h-[225px] w-full flex-col flex-wrap rounded-b-lg border-x border-b border-solid border-gray-200 dark:border-default bg-white dark:bg-surface-card sm:h-[180px]"
                        >
                            <CText class="mx-4 mb-1 mt-4 font-semibold text-black dark:text-txt-headings">
                                {{ article.title }}
                            </CText>
                            <CButton
                                class="mb-4 mt-auto w-[150px] font-semibold"
                                :href="article.link"
                                icon="chevron-right"
                                icon-right
                                target="_blank"
                                variant="primary-link"
                            >
                                Prečítať viac
                            </CButton>
                        </div>
                    </div>
                </div>
            </VSlickCarousel>
        </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import 'v-slick-carousel/style.css'
import { VSlickCarousel } from 'v-slick-carousel'
import type { Settings } from 'v-slick-carousel'

interface Article {
    title: string;
    link: string;
    img?: string;
}

const settings: Settings = {
  groupsToShow: 1,
  groupsToScroll: 2,
  infinite: true,
  arrows: false,
  centerMode: true,
  centerPadding: '15%',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: false,
        groupsToShow: 3,
        groupsToScroll: 3,
      }
    }
  ]
}

const articles = ref<Article[]>([
    {
        title: 'Ema a Filip kontrolujú predvolebné kampane k jesenným voľbám. Sú kandidáti skutočne...',
        link: 'https://dennikn.sk/3012618/ema-23-a-filip-21-kontroluju-predvolebne-kampane-k-jesennym-volbam-su-kandidati-skutocne-transparentni/?ref=list',
        img: '/images/b2b-article-thumbnails/thumbnail-1.png'
    },
    {
        title: 'Pohoda 2022: Andrea prezradila, čo sa skrýva za prípravami najväčšieho slovenského festivalu.',
        link: 'https://dennikn.sk/3008796/pohoda-2022-andrea-24-prezradila-co-sa-skryva-za-pripravami-najvacsieho-slovenskeho-festivalu/',
        img: '/images/b2b-article-thumbnails/thumbnail-2.png'
    },
    {
        title: 'Bezdomovci na Slovensku nie sú. Aspoň tak sa tvária slovenské zákony, hovorí Martin z OZ Vagus',
        link: 'https://www.aktuality.sk/clanok/u1R5Dtp/bezdomovci-na-slovensku-nie-su-aspon-tak-sa-tvaria-slovenske-zakony-hovori-martin-z-oz-vagus/',
        img: '/images/b2b-article-thumbnails/thumbnail-3.png'
    }
])

// We don't need this method anymore as we're using href directly in the template
// const linkTo = (link: string) => {
//     window.location.href = link
// }
</script>

<style lang="postcss" scoped>
.carousel {
    padding: 20px
}

.carousel :deep(.v-slick-arrow.prev:before) {
    margin-left: -20px;
}

.carousel :deep(.v-slick-arrow:before) {
    font-size: 40px;
    color: grey;
}
</style>